import { Box, Flex, Text } from '@chakra-ui/react';

export function Vendas({ valor, lineColor, title }) {
  return (
    <Box position="relative">
      <Flex flexDir="column">
        <Text as="span" fontSize="14px" color="#2d2d2d" textTransform="lowercase">
          {title}
        </Text>
        <Text as="span" fontSize="14px" color="#2d2d2d" textTransform="lowercase">
          <Text as="strong" textTransform="initial">
            {valor}
          </Text>
        </Text>
      </Flex>
    </Box>
  );
}
